/**
 * AI俳優ウィザードの出力 (base64) を multipart 送信用の File に変換するヘルパー。
 *
 * ProfilePage / ExclusiveActorsPage / org-admin/OrgActorManagementPage /
 * components/admin/ActorManagementPageBase の4箇所に同じ変換がコピペされていたのを
 * ここへ集約したもの。挙動 (ファイル名・MIME のフォールバック) は元のまま。
 */

/**
 * data: URL を fetch して Blob 化し File にする。
 * base64 → Blob の変換に fetch を使うのはブラウザ内で完結する定石で、
 * ネットワークアクセスは発生しない。
 */
async function dataUrlToFile(dataUrl: string, filename: string, type: string): Promise<File> {
  const blob = await fetch(dataUrl).then((res) => res.blob());
  return new File([blob], filename, { type });
}

/** {@link toCharacterSheetFiles} の入力 (WizardData の必要部分のみ) */
export interface CharacterSheetSource {
  characterSheetBase64: string;
  characterSheetMimeType: string | null;
  faceImageBase64: string;
}

/** {@link toCharacterSheetFiles} の戻り値 */
export interface CharacterSheetFiles {
  characterSheetFile: File;
  faceImageFile: File;
}

/**
 * キャラクターシート / 顔画像の base64 を、AI俳優作成 API に渡す File へ変換する。
 *
 * - キャラクターシート: `character_sheet.png` / MIME は wizard の値、未設定なら `image/png`
 * - 顔画像: `face.png` / MIME は常に `image/png` (crop 結果が PNG 固定のため)
 */
export async function toCharacterSheetFiles(
  source: CharacterSheetSource,
): Promise<CharacterSheetFiles> {
  const characterSheetFile = await dataUrlToFile(
    `data:${source.characterSheetMimeType};base64,${source.characterSheetBase64}`,
    'character_sheet.png',
    source.characterSheetMimeType || 'image/png',
  );

  const faceImageFile = await dataUrlToFile(
    `data:image/png;base64,${source.faceImageBase64}`,
    'face.png',
    'image/png',
  );

  return { characterSheetFile, faceImageFile };
}
